/**
 * Created by Pankaj singh on 05-Aug-2021
 * */
export enum WildPart {
    BOTTOM = "bottom_part",
    BOTTOM_CUT = "bottom_frame_cut_part",
    TOP = "wild_top_part",
    TEXT = "wild_text"
}